import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { IconLookup, IconProp } from '@fortawesome/fontawesome-svg-core';
import { faBluesky, faFacebook, faInstagram, faXTwitter } from '@fortawesome/free-brands-svg-icons';

import { ENVIRONMENT } from '@environment';
import { SocialService } from '@usheru-hff/channel-social-updates/domain';
import { Post, SocialNetworkLink } from '@usheru-hff/shared/domain';
import { SharedUtilsModule } from '../../../../../shared/utils/src/lib/shared-utils.module';

import { FaIconComponent, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';
import { NgIf, NgFor } from '@angular/common';

/**
 * //TODO docs favio
 * //TODO barbeitoalex propostal - remove .spec.ts
 * //TODO barbeitoalex propostal - update contructor position
 * //TODO barbeitoalex propostal - update translate text with an observable to the current language
 * //TODO barbeitoalex propostal - update translate text with an observable to the current language changes
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-social-feed',
  templateUrl: './social-feed.component.html',
  styleUrls: ['./social-feed.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink, NgFor, FaIconComponent, SharedUtilsModule, FontAwesomeModule, SharedUtilsModule]
})
export class SocialFeedComponent implements OnInit {
  private readonly env = inject(ENVIRONMENT);

  constructor(
    private socialService: SocialService,
    private cd: ChangeDetectorRef
  ) {}

  @Input() socialFeeds: SocialNetworkLink[];

  @Input() hidedElementIfNoData: HTMLElement;

  posts: Post[];

  @Output() socialFeedFound = new EventEmitter<boolean>();

  private readonly showBlueSky = this.env?.showBlueSky;

  ngOnInit(): void {
    this.socialService.getSocialFeed().subscribe(posts => {
      this.posts = posts.map(p => {
        // check if end with a video extension
        if (
          p.attachment.endsWith('.mp4') ||
          p.attachment.endsWith('.mov') ||
          p.attachment.endsWith('.avi') ||
          p.attachment.endsWith('.flv') ||
          p.attachment.endsWith('.wmv') ||
          p.attachment.endsWith('.webm')
        ) {
          p.type = 'video';
        } else {
          p.type = 'img';
        }
        return p;
      });

      this.socialFeedFound.emit(this.posts.length > 0);

      this.cd.detectChanges();
    });
  }

  getIcon(name: string): IconLookup | undefined {
    switch (name) {
      case 'Bluesky':
        return this.showBlueSky ? (faBluesky as IconLookup) : undefined;
      case 'twitter':
        return faXTwitter as IconLookup;
      case 'facebook':
        return faFacebook as IconLookup;
      case 'instagram':
        return faInstagram as IconLookup;
      default:
        return undefined;
    }
  }

  getIconProp(name: string): IconProp {
    switch (name) {
      case 'blluesky':
        return 'bluesky';
      case 'facebook':
        return 'facebook';
      case 'twitter':
        return 'twitter';
      case 'instagram':
        return 'instagram';
      default:
        return null;
    }
  }
}
